import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface InteractionListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class InteractionListPage extends Component<InteractionListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.interaction_list }}
                pages={{
                    entity: InferenceEntities.interaction(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}